// extracted by css-extract-rspack-plugin
export default {"anchor":"Anchor__anchor--L3oEn","activeScroll":"Anchor__activeScroll--fcqxc","arrow":"Anchor__arrow--RqGUf"};